import React from 'react';
import PropTypes from 'prop-types';

import PubSub from 'pubsub-js';

import api from 'js/api-helper';
import checkApiPropTypes from 'js/check-api-prop-types';
import topics from 'js/topics.json';

import AddToCartButton from '../add-to-cart-button';
import AddToCartResponse from 'components/contact-lens-page/add-to-cart-response';
import Form from 'components/form';
import PageSpinner from 'components/page-spinner';
import Select from 'components/form-elements/select';
import Button from 'components/button';
import ValidationErrorTexts from 'components/validation-error-texts';
import NotifyMeModal from 'components/notify-me-modal/notify-me-modal';
import cn from 'classnames';

class GlassesForm extends React.Component {
  static propTypes = {
    updateSizeEndpoint: PropTypes.string,
    addToCartEndpoint: PropTypes.string,
    hideAddToCartButton: PropTypes.bool,
    onBeforeUpdateSize: PropTypes.func,
    onRef: PropTypes.func,
    sizeSelect: PropTypes.exact(Select.propTypes),
    submitLabel: PropTypes.string,
    updateSize: PropTypes.func,
    validationErrors: PropTypes.exact(ValidationErrorTexts.propTypes),
    productCategory: PropTypes.string,
    productName: PropTypes.string,
    productBrand: PropTypes.string,
    notifyMeData: PropTypes.exact(NotifyMeModal.propTypes)
  };

  static propTypesMeta = {
    productName: 'exclude',
    productCategory: 'exclude',
    productBrand: 'exclude'
  };

  static defaultProps = {
    onRef: () => {}
  };

  state = {
    isLoading: false,
    isNotifyMeModalOpen: false,
    selectedProductValues: {}
  };

  componentDidMount() {
    this.initializeSelectedProductValues();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({ isLoading: false });
    }

    if (prevProps.sizeSelect !== this.props.sizeSelect) {
      this.initializeSelectedProductValues();
    }
  }

  initializeSelectedProductValues = () => {
    const { sizeSelect } = this.props;
    if (sizeSelect && sizeSelect.options) {
      const initialValues = {};
      if (sizeSelect.options.length === 1) {
        initialValues[sizeSelect.name] = sizeSelect.options[0].value;
      } else if (sizeSelect.defaultSelectedValue) {
        initialValues[sizeSelect.name] = sizeSelect.defaultSelectedValue;
      } else {
        const selectedOption = sizeSelect.options.find(
          option => option.selected === true
        );
        if (selectedOption) {
          initialValues[sizeSelect.name] = selectedOption.value;
        }
      }
      if (Object.keys(initialValues).length > 0) {
        this.setState({ selectedProductValues: initialValues });
      }
    }
  };

  setIsNotifyMeModalOpen = isOpen => {
    this.setState({ isNotifyMeModalOpen: isOpen });
  };

  onBeforeAddToCart = () => {
    this.setState({ isLoading: true });
  };

  onAddToCartResponse = response => {
    PubSub.publish(topics.cartUpdate, response);
    checkApiPropTypes(
      response,
      AddToCartResponse.propTypes,
      'AddToCartResponse'
    );
    this.setState({ isLoading: false });
  };

  onChange = value => {
    const { sizeSelect } = this.props;

    if (sizeSelect && sizeSelect.name) {
      this.setState(prevState => ({
        selectedProductValues: {
          ...prevState.selectedProductValues,
          [sizeSelect.name]: value[sizeSelect.name]
        }
      }));
    }

    if (this.props.updateSizeEndpoint) {
      this.props.onBeforeUpdateSize();

      api.execute(this.props.updateSizeEndpoint, value).then(response => {
        this.props.updateSize(response);
      });
    }
  };

  onNotifyMeButtonClick = () => {
    // Only open the modal if all required options have been selected
    if (Object.keys(this.state.selectedProductValues).length !== 0) {
      this.setIsNotifyMeModalOpen(true);
    }
  };

  render() {
    const {
      sizeSelect,
      notifyMeData,
      productName,
      productCategory,
      productBrand
    } = this.props;
    const { isNotifyMeModalOpen, selectedProductValues } = this.state;

    return !sizeSelect ? null : (
      <>
        <Form
          className="glasses-form"
          endpoint={this.props.addToCartEndpoint}
          onBeforeSubmit={this.onBeforeAddToCart}
          onChange={this.onChange}
          onRef={this.props.onRef}
          onResponse={this.onAddToCartResponse}
          showSubmitButton={false}
        >
          {sizeSelect && sizeSelect.options && sizeSelect.options.length > 0 && (
            <div
              className={cn('glasses-form-select', {
                'is-hidden': sizeSelect.options.length === 1
              })}
            >
              <Select
                onChange={this.onChange}
                validationErrors={this.props.validationErrors}
                validations="isRequired"
                {...sizeSelect}
              />
            </div>
          )}

          <PageSpinner
            shouldContainInParent={true}
            isLoading={this.state.isLoading}
          />
          {!this.props.hideAddToCartButton && (
            <AddToCartButton text={this.props.submitLabel} />
          )}
          {notifyMeData ? (
            <Button
              className="glasses-form-notify-me-btn"
              iconAfter="mail"
              onClick={this.onNotifyMeButtonClick}
              text={notifyMeData.buttonLabel}
              theme={Button.themes.outlineOrange}
            />
          ) : null}
        </Form>
        {notifyMeData && (
          <NotifyMeModal
            {...notifyMeData}
            productName={productName}
            productCategory={productCategory}
            productBrand={productBrand}
            className="glasses-form-notify-me"
            toggleButtonClassName="glasses-form-notify-me-btn"
            isOpen={isNotifyMeModalOpen}
            selectedProductValues={selectedProductValues}
            setIsOpen={this.setIsNotifyMeModalOpen}
          />
        )}
      </>
    );
  }
}

export default GlassesForm;
